export default "__VITE_ASSET__def6deae__"